import type { SupplyProgram } from '@shared/types';
import { PROGRAM_LABELS } from '@shared/types';
import { SUPPLY_PROGRAMS } from '@shared/validation';

/**
 * All / Kitchen / Cleaning chips for the logistics screens. `null` means all —
 * the query param is simply omitted, which the worker treats as unscoped.
 */
export default function ProgramFilter({
  value,
  onChange,
  className = '',
}: {
  value: SupplyProgram | null;
  onChange: (p: SupplyProgram | null) => void;
  className?: string;
}) {
  const options: { key: string; label: string; value: SupplyProgram | null }[] = [
    { key: 'all', label: 'All', value: null },
    ...SUPPLY_PROGRAMS.map((p) => ({ key: p, label: PROGRAM_LABELS[p], value: p })),
  ];

  return (
    <div className={`flex gap-1.5 ${className}`} role="group" aria-label="Filter by supply program">
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
          className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            value === o.value
              ? 'bg-dcvfd-accent text-white'
              : 'bg-surface-raised border border-border-subtle text-zinc-300 hover:text-white'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
